// extracted by mini-css-extract-plugin
export default {"acknowledgmentDialog":"m5i4n"};